import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { MenuIcon, XIcon } from 'lucide-react';
const LegalNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    name: 'Product',
    href: '/#product'
  }, {
    name: 'Components',
    href: '/#components'
  }, {
    name: 'Platform',
    href: '/#platform'
  }, {
    name: 'Security',
    href: '/#security'
  }, {
    name: 'Community',
    href: '/community'
  }, {
    name: 'Pricing',
    href: '/#pricing'
  }];
  return <header className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-1280">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-1281">
        <div className="flex items-center gap-2" data-id="element-1282">
          <Link to="/" className="flex items-center group" data-id="element-1283">
            <img src="https://cdn.magicpatterns.com/uploads/fMJnv7yQ9EawQ6b54Tnvxq/FWLogo.png" alt="FluidWeb Logo" className="h-8 transition-opacity group-hover:opacity-80" data-id="element-1284" />
          </Link>
        </div>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-1285">
          {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1286">
                {item.name}
              </a> : <Link key={index} to={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1287">
                {item.name}
              </Link>)}

          <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap" data-id="element-1288">
            Get a demo
          </a>
        </nav>

        <button className="md:hidden text-gray-700 p-2" onClick={() => setIsOpen(!isOpen)} data-id="element-1289">
          {isOpen ? <XIcon size={24} data-id="element-1290" /> : <MenuIcon size={24} data-id="element-1291" />}
        </button>
      </div>

      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 absolute w-full left-0 top-full shadow-xl" data-id="element-1292">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-1293">
            {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1294">
                  {item.name}
                </a> : <Link key={index} to={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1295">
                  {item.name}
                </Link>)}
            <div className="border-t border-gray-100 pt-4" data-id="element-1296">
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors text-center font-medium block" data-id="element-1297">
                Get a demo
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
const PrivacyPolicy = () => {
  return <div className="w-full min-h-screen font-sans" data-id="element-1298">
      <LegalNavbar data-id="element-1299" />
      <main className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-1300">
        <h1 className="text-3xl font-bold mb-6" data-id="element-1301">
          FluidForm, Inc. — Privacy Policy
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-1302">Last Updated: August 16, 2025</p>
        <p className="mb-8" data-id="element-1303">
          Welcome to FluidForm, Inc. ("FluidForm," "we," "us," or "our"). This
          Privacy Policy describes how we collect, use, and share information
          about you when you use our services ("Services"). By using our
          Services, you agree to the terms outlined in this policy.
        </p>
        <section className="mb-8" data-id="element-1304">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1305">
            1. Changes to This Privacy Policy
          </h2>
          <p className="mb-4" data-id="element-1306">
            We may update this policy occasionally. If material changes occur,
            we will notify you (e.g., via email or in-product notification).
            Your continued use of the Services after the update constitutes
            acceptance.
          </p>
        </section>
        <section className="mb-8" data-id="element-1307">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1308">
            2. Information We Collect
          </h2>
          <h3 className="text-lg font-medium mb-2" data-id="element-1309">
            A. Information You Provide
          </h3>
          <ul className="list-disc pl-8 mb-4" data-id="element-1310">
            <li className="mb-2" data-id="element-1311">
              <span className="font-medium" data-id="element-1312">Account Info:</span> Such as email,
              name, and billing details.
            </li>
            <li className="mb-2" data-id="element-1313">
              <span className="font-medium" data-id="element-1314">Support Communications:</span>{' '}
              Information you send when contacting support.
            </li>
            <li className="mb-2" data-id="element-1315">
              <span className="font-medium" data-id="element-1316">User Content:</span> Any content you
              upload, create, or submit within the Services.
            </li>
          </ul>
          <h3 className="text-lg font-medium mb-2" data-id="element-1317">
            B. Automatically Collected Info
          </h3>
          <ul className="list-disc pl-8 mb-4" data-id="element-1318">
            <li className="mb-2" data-id="element-1319">
              <span className="font-medium" data-id="element-1320">Device & Usage Data:</span> Includes
              IP address, browser type, device identifiers, time stamps, and
              activity logs.
            </li>
            <li className="mb-2" data-id="element-1321">
              <span className="font-medium" data-id="element-1322">
                Cookies & Tracking Technologies:
              </span>{' '}
              We use cookies and similar tools for functionality, analytics, and
              improving your experience.
            </li>
          </ul>
          <h3 className="text-lg font-medium mb-2" data-id="element-1323">C. Third-Party Data</h3>
          <p className="mb-4" data-id="element-1324">
            We may receive information from third parties (e.g., if you sign up
            via Google or Slack), subject to your permissions and their
            policies.
          </p>
        </section>
        <section className="mb-8" data-id="element-1325">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1326">
            3. How We Use Your Information
          </h2>
          <p className="mb-4" data-id="element-1327">We use your data to:</p>
          <ul className="list-disc pl-8 mb-4" data-id="element-1328">
            <li className="mb-2" data-id="element-1329">
              Provide, maintain, and enhance the Services.
            </li>
            <li className="mb-2" data-id="element-1330">
              Communicate updates, respond to inquiries, and send technical
              notices.
            </li>
            <li className="mb-2" data-id="element-1331">Process payments and manage subscriptions.</li>
            <li className="mb-2" data-id="element-1332">Personalize your user experience.</li>
            <li className="mb-2" data-id="element-1333">
              Protect against fraud and ensure safety and integrity.
            </li>
            <li className="mb-2" data-id="element-1334">Comply with legal obligations.</li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1335">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1336">
            4. Information Sharing & Disclosure
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-1337">
            <li className="mb-2" data-id="element-1338">
              <span className="font-medium" data-id="element-1339">Service Providers:</span> We share
              your info with vendors assisting in operations (e.g., payment
              processors, analytics tools).
            </li>
            <li className="mb-2" data-id="element-1340">
              <span className="font-medium" data-id="element-1341">Legal & Safety:</span> We disclose
              information if required by law or to protect rights.
            </li>
            <li className="mb-2" data-id="element-1342">
              <span className="font-medium" data-id="element-1343">Aggregated Data:</span> We may use
              anonymized, aggregated data for analytics or research.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1344">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1345">
            5. Data Retention & Deletion
          </h2>
          <p className="mb-4" data-id="element-1346">
            We retain personal data as long as necessary to provide the
            Services, comply with legal obligations, or for legitimate business
            purposes. You may request deletion of your personal information in
            compliance with applicable laws.
          </p>
        </section>
        <section className="mb-8" data-id="element-1347">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1348">
            6. Your Privacy Choices
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-1349">
            <li className="mb-2" data-id="element-1350">
              <span className="font-medium" data-id="element-1351">Account Settings:</span> Manage
              notifications, data preferences, or privacy-related toggles where
              applicable.
            </li>
            <li className="mb-2" data-id="element-1352">
              <span className="font-medium" data-id="element-1353">Opt-Out Rights:</span> You may opt
              out of non-essential communications or data uses as allowed by
              law.
            </li>
            <li className="mb-2" data-id="element-1354">
              <span className="font-medium" data-id="element-1355">Access & Deletion Requests:</span>{' '}
              Contact us to access, update, or delete your information—subject
              to lawful exceptions.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1356">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1357">7. Security Measures</h2>
          <p className="mb-4" data-id="element-1358">
            We employ administrative, technical, and physical safeguards to
            protect your information. We regularly review our practices and
            engage with third-party audits and assessments to ensure data
            protection.
          </p>
        </section>
        <section className="mb-8" data-id="element-1359">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1360">8. Privacy of Minors</h2>
          <p className="mb-4" data-id="element-1361">
            Users must be at least 13 years old to use our Services. We do not
            knowingly collect personal data from children under 13. If you're
            under 13, please do not provide personal data.
          </p>
        </section>
        <section className="mb-8" data-id="element-1362">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1363">9. International Users</h2>
          <p className="mb-4" data-id="element-1364">
            If you're in regions like the EU, UK, or other privacy-regulated
            areas, we comply with applicable laws such as GDPR. Contact us if
            you'd like to understand how your rights apply.
          </p>
        </section>
        <section className="mb-8" data-id="element-1365">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1366">10. Contact Us</h2>
          <p className="mb-4" data-id="element-1367">
            If you have any questions or concerns about this policy, contact us
            at:
          </p>
          <p className="mb-4" data-id="element-1368">
            FluidForm, Inc.{' '}
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-1369">
              support@fluid-form.ai
            </a>
          </p>
        </section>
      </main>
      <Footer data-id="element-1370" />
    </div>;
};
export default PrivacyPolicy;